




































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'OmnichannelSpaceAvailabilityBindSelector'

  resources:
    space_resource:
      resourceName: 'space'
      slug: 'suppliers/:supplierId/spaces/:space.id/edit'
      fetch: false

    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:supplierId/audience_availabilities'
      fetch: false

  vue:
    props: ['space', 'options']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
    }

    data: ->
      selectedSpaceAvailabilities: []
      selectedAvailabilities: []

    mounted: ->
      @fetchAvailabilities()

    computed:
      creativeId: -> @$route.params.audienceCreativeId
      supplierId: -> @options?.supplierId || @$store.member.supplier.id
      spaceAvailabilityIds: -> @space.availability_ids || []
      spaceAvailabilities: ->
        items = []
        for availability in (@availabilities || [])
          items.push availability if availability.id in @spaceAvailabilityIds
        items

      segmentRenamed: -> @space.segment_renamed || @space.syncing_segments

      spaceAvailabilitiesTableData: ->
        for availability in @spaceAvailabilities
          id: availability.id
          data: availability
          experience: availability.title
          location: @$options.filters.formatLocation(availability)
          street: availability.venue_street
          venue: availability.venue_name

      availabilitiesTableData: ->
        for availability in @availabilities
          continue if availability.id in @spaceAvailabilityIds
          id: availability.id
          data: availability
          experience: availability.title
          location: @$options.filters.formatLocation(availability)
          street: availability.venue_street
          venue: availability.venue_name

      optionsForBindSelector: ->
        # required: true
        # title: 'Select which venues your account handle represents'
        # description: 'Select the venues that have this segment available to sponsors'
        addButtonText: 'Setup Venue'
        addExistingButtonText: 'Add Existing Venue'

    methods:
      hiSpaceAvailabilitiesSelectionChange: (availabilities) ->
        @selectedSpaceAvailabilities = availabilities
      hiSpaceAvailabilitiesRowClick: (row) ->
        @$refs.spaceAvailabilitiesTable.toggleRowSelection row
      hiUnbindSpaceAvailability: (availability) ->
        @unbindAvailabilitiesFromSpaceTrigger [availability]
      hiUnbindSelectedSpaceAvailabilities: ->
        @unbindAvailabilitiesFromSpaceTrigger @selectedSpaceAvailabilities

      hiAvailabilitiesSelectionChange: (availabilities) ->
        @selectedAvailabilities = availabilities
      hiAvailabilitiesRowClick: (row) ->
        @$refs.availabilitiesTable.toggleRowSelection row
      hiBindAvailability: (availability) ->
        @bindAvailabilitiesToSpaceTrigger [availability]
      hiBindSelectedAvailabilities: ->
        @$refs.bindSelector.close()
        @bindAvailabilitiesToSpaceTrigger @selectedAvailabilities

      bindAvailabilitiesToSpaceTrigger: (availabilities) ->
        @$emit 'bind'
        for chunk in @chunkArray(availabilities, 500)
          payload =
            availability_ids: chunk.map((a) => a.id)
          @triggerResource 'space_resource', 'bind_availabilities', payload
      onSpaceResourceBindAvailabilities: (_, item) ->
        @$emit 'change', item

      unbindAvailabilitiesFromSpaceTrigger: (availabilities) ->
        @$emit 'unbind'
        for chunk in @chunkArray(availabilities, 500)
          payload = { availability_ids: chunk.map((a) => a.id) }
          @triggerResource 'space_resource', 'unbind_availabilities', payload
      onSpaceResourceUnbindAvailabilities: (payload, item) ->
        @$emit 'unbindAll' if payload.availability_ids.length is @spaceAvailabilityIds.length
        @$refs.spaceAvailabilitiesTable?.clearSelection()
        @$emit 'change', item

      fetchAvailabilities: ->
        params = { quick_list: true }
        params.audience_creative_id = @creativeId if @creativeId
        @fetch 'availabilities', params

export default VueOptions.vue settings
